export const canUseMarketing = (u) =>
  !!u && (u.role === "admin" || (u.role === "user" && (u.department || "").toLowerCase().includes("marketing")));
